/* global React, Icon */

function Footer() {
  const t = (k) => window.i18n.t(k);
  const loc = window.i18n.getLocale();

  const cols = () => [
    {
      h: t("footer.col.product.h"),
      links: [
        [t("footer.col.product.link.1"), "#problem"],
        [t("footer.col.product.link.2"), "#directions"],
        [t("footer.col.product.link.3"), "#case"],
        [t("footer.col.product.link.4"), "#calculator"],
        [t("footer.col.product.link.5"), "#pricing"],
      ],
    },
    {
      h: t("footer.col.directions.h"),
      links: [
        [t("footer.col.directions.link.1"), "/chatbots.html"],
        [t("footer.col.directions.link.2"), "/chatbots.html"],
        [t("footer.col.directions.link.3"), "/chatbots.html"],
        [t("footer.col.directions.link.4"), "/chatbots.html"],
        [t("footer.col.directions.link.5"), "/chatbots.html"],
      ],
    },
    {
      h: t("footer.col.company.h"),
      links: [
        [t("footer.col.company.link.1"), "#"],
        [t("footer.col.company.link.2"), "#"],
        [t("footer.col.company.link.3"), "#"],
        [t("footer.col.company.link.4"), "#"],
        [t("footer.col.company.link.5"), "#"],
      ],
    },
    {
      h: t("footer.col.resources.h"),
      links: [
        [t("footer.col.resources.link.1"), "#"],
        [t("footer.col.resources.link.2"), "#"],
        [t("footer.col.resources.link.3"), "#"],
        [t("footer.col.resources.link.4"), "#"],
        [t("footer.col.resources.link.5"), "#"],
        [t("footer.col.resources.link.6"), "#"],
      ],
    },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-main">
          <div className="footer-brand">
            <a href="#" className="nav-logo">
              <span className="nav-logo-mark">H</span>
              <span>
                healbot<span style={{ color: "var(--muted-2)", fontWeight: 500 }}>.pro</span>
              </span>
            </a>
            <p>{t("footer.brand.body")}</p>
            <div className="footer-badges">
              <span className="footer-badge">
                <Icon name="shield" size={13} color="var(--teal-ink)" stroke={1.8} />
                {t("footer.badge.gdpr")}
              </span>
              <span className="footer-badge">{t("footer.badge.madein")}</span>
            </div>
          </div>
          {cols().map((c) => (
            <div className="footer-col" key={c.h}>
              <h5>{c.h}</h5>
              <ul>
                {c.links.map(([l, h]) => (
                  <li key={l}>
                    <a href={h}>{l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="footer-bot">
          <div className="cpy">{t("footer.copyright")}</div>
          <span className="footer-lang-static">{loc === "ru" ? "🇷🇺 RU" : "🇺🇦 UA"}</span>
        </div>
      </div>
    </footer>
  );
}

window.Footer = Footer;
